export default "/assets/webpack-assets/GT-Walsheim-Pro-Regular-Oblique.b980f940fd1a08be75325ab4db0b8307.woff";